@import "~animatewithsass/animate.scss";

.nav-header {
  padding: 0;
  ul {
    list-style-type: none;
    padding: 0;
    li {
      margin-left: 10px;
      a {
        padding: 22px 5px 22px 0;
        display: block;
        text-decoration: none;
        font-size: 20px;
        font-weight: 200;
      }
    }
  }

  .activeLink {
    border-right: 0 !important;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding-left: 20px;
    margin-left: -6px;
    margin-top: -1px;
    @include pulse($duration:0.4s);
    a{
    }
  }
}





// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/recipe-links/recipe-links.scss